import { IPagination } from '../../../shared/interfaces/shared/IPagination';
import { requests } from '../../../utils/api/api.service';
import { BASE_URL } from '../../../utils/api/endpoints';

export const AdminOfficeOrderlyService = {
  getAll: (pagination: IPagination) =>
    requests.get(`${BASE_URL}/office-orderly`, pagination),
};
